import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { MessagesSquare, ArrowRight } from "lucide-react";
import { useI18n } from "../i18n";
import { Reveal } from "./Reveal";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function HomeDiscussions() {
  const { tr } = useI18n();
  const [data, setData] = useState(null);

  useEffect(() => {
    axios.get(`${API}/discussions-active`).then((r) => setData(r.data)).catch(() => {});
  }, []);

  if (!data || (!data.active.length && !data.starters.length)) return null;
  const cards = [...data.active, ...data.starters];

  return (
    <section id="home-discussions" data-testid="home-discussions-section" className="py-20 bg-[#FCFAFF]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <Reveal>
          <span className="wp-eyebrow">{tr("Community Pulse")}</span>
          <h2 className="text-base md:text-lg font-extrabold text-[#0F2557] mt-2 max-w-xl">
            {tr("Live discussions from around the world — every country, state and district has its own board.")}
          </h2>
        </Reveal>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-8">
          {cards.map((c) => (
            <Reveal key={c.key}>
              <Link to={`${c.url}#community`} data-testid="home-discussion-card"
                className="block border border-[#D8CCF2] bg-white rounded-3xl p-5 hover:border-[#7C3AED] hover:-translate-y-0.5 transition-all group h-full">
                <div className="flex items-center justify-between gap-3">
                  <span className="font-extrabold text-[#0F2557] group-hover:text-[#7C3AED] transition-colors">{c.flag} {c.name}</span>
                  <span className="text-[0.6rem] font-extrabold uppercase tracking-widest text-[#7C3AED] bg-[#F5F3FF] rounded-full px-2.5 py-1">{tr(c.level)}</span>
                </div>
                {c.count > 0 ? (
                  <>
                    <p className="text-sm text-[#475569] mt-3 line-clamp-2 leading-relaxed">"{c.last_text}"</p>
                    <div className="flex items-center justify-between mt-3 text-[0.65rem] font-bold text-[#94A3B8]">
                      <span>— {c.last_author}</span>
                      <span className="flex items-center gap-1"><MessagesSquare size={11} /> {c.count} {tr(c.count === 1 ? "message" : "messages")}</span>
                    </div>
                  </>
                ) : (
                  <p className="text-sm text-[#64748B] mt-3 flex items-center gap-2">
                    {tr("Be the first to start the conversation")} <ArrowRight size={13} className="text-[#7C3AED]" />
                  </p>
                )}
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
